interface MusicIqIconProps {
  className?: string;
}

export function MusicIqIcon({ className }: MusicIqIconProps) {
  return (
    <img
      src="/images/music-iq/music-iq.svg"
      alt="Music IQ"
      className={className}
    />
  );
}

MusicIqIcon.displayName = 'MusicIqIcon';
